<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="campaigncharts" *ngIf="data != null">
        <div class="ui-g-12 ui-md-12 ui-sm-12">
            <div class="chart-container">
                <chart [options]="segmentDistributionChart.options"
                       (load)="setChartInstance(segmentDistributionChart, $event.context)"></chart>
            </div>
        </div>
    </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-kpi/store-customers-kpi.component.html